import React from 'react';
import { DataPackageV2Component } from '@vivli/shared/features/data-package/components';
import { useUserPermissions } from '@vivli/features/users/infrastructure/hook';
import { IDataPackage, IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';

interface DownloadOnlyDataPackageFeatureProps {
    dataPackageId?: string;
    //data package id for study IPD package
    secondaryDataPackageId?: string;
    overrideDataPackage?: IDataPackage;
    datasetMetaDataDoi?: string;
    studyOrgId?: string;
    onReady?: () => void;
    onClose?: () => void;
    disallowDownload?: boolean;
    showPubliclyAvailable?: boolean;
    hideForPubliclyAvailableTypes?: any[];
    requiredTypes?: string[];
    availableTypes?: any[];
    showVerifyButton?: boolean;
    title?: string;
    onDataPackageLoaded?: (dataPackage: IDataPackage) => void;
    secondaryFilesToShow?: IDataPackageFileDescriptor[];
    onSecondaryDataPackageUpdated?: (dataPackage: IDataPackage) => void;
    onPackageUpdated?: (dataPackage: IDataPackage) => void;
}

export const DownloadOnlyDataPackageFeature = ({
    dataPackageId,
    secondaryDataPackageId,
    datasetMetaDataDoi,
    studyOrgId,
    onReady,
    onClose,
    disallowDownload,
    showPubliclyAvailable,
    availableTypes,
    requiredTypes,
    hideForPubliclyAvailableTypes,
    showVerifyButton,
    title,
    onDataPackageLoaded,
    secondaryFilesToShow,
    onSecondaryDataPackageUpdated,
    overrideDataPackage,
    onPackageUpdated
}: DownloadOnlyDataPackageFeatureProps) => {
    const { studyPermissions } = useUserPermissions();

    return (
        <DataPackageV2Component
            allowPubliclyAvailableEdit={studyPermissions.canModifyPubliclyAvailable(studyOrgId)}
            dataPackageId={dataPackageId}
            secondaryDataPackageId={secondaryDataPackageId}
            readOnly={true}
            allowDownload={!disallowDownload}
            allowUpload={false}
            allowSubmit={false}
            hideFileType={!showPubliclyAvailable}
            showPubliclyAvailable={showPubliclyAvailable}
            onReady={onReady}
            datasetMetaDataDoi={datasetMetaDataDoi}
            studyOrgId={studyOrgId}
            recordFileDownload={true}
            onClose={onClose}
            requiredTypes={requiredTypes}
            availableTypes={availableTypes}
            hideForPubliclyAvailableTypes={hideForPubliclyAvailableTypes}
            showVerifyButton={showVerifyButton}
            title={title}
            onDataPackageLoaded={onDataPackageLoaded}
            secondaryFilesToShow={secondaryFilesToShow}
            onSecondaryDataPackageUpdated={onSecondaryDataPackageUpdated}
            overrideDataPackage={overrideDataPackage}
            onPackageUpdated={onPackageUpdated}
        />
    );
};
